import { useSyncExternalStore } from 'react';
import { ServerOff } from 'lucide-react';
import { useTranslation } from '../i18n';
import { getApiStatus, subscribeApiStatus } from '../services/apiStatus';

/**
 * Slim banner shown while the API answers 503 (maintenance, a deploy). It
 * clears itself on the next successful answer. Neutral wording: it never
 * names the app, so it is safe in discreet mode as well.
 */
export function ServiceStatusNotice() {
  const { t } = useTranslation();
  const status = useSyncExternalStore(
    subscribeApiStatus,
    getApiStatus,
    () => 'ok' as const
  );

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 top-0 z-[54]"
    >
      {status === 'unavailable' && (
        <div className="flex items-center justify-center gap-2 border-b border-white/10 bg-hc-overlay px-4 pb-1 pt-[max(0.25rem,env(safe-area-inset-top))] text-center text-xs text-white/80">
          <ServerOff className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span>{t('api.status.unavailable')}</span>
        </div>
      )}
    </div>
  );
}
